export enum InspectionViewType {
    SUMMARY_TAB = 0,
    PARTICULARS_TAB = 1,
    NOTABLE_ITEMS_TAB = 2,
    GRADING_TAB = 3,
    DOCUMENT_TAB = 4,
    GRADING_COMPARISON_TAB = 5,
    IMAGES_MODAL_VIEW = "IMAGES_MODAL_VIEW"
}

export const InspectionViewTypes: { [key: string]: InspectionViewType } = {
    SUMMARY_TAB: InspectionViewType.SUMMARY_TAB,
    PARTICULARS_TAB: InspectionViewType.PARTICULARS_TAB,
    NOTABLE_ITEMS_TAB: InspectionViewType.NOTABLE_ITEMS_TAB,
    GRADING_TAB: InspectionViewType.GRADING_TAB,
    DOCUMENT_TAB: InspectionViewType.DOCUMENT_TAB,
    GRADING_COMPARISON_TAB: InspectionViewType.GRADING_COMPARISON_TAB,
    IMAGES_MODAL_VIEW: InspectionViewType.IMAGES_MODAL_VIEW
};
